import { BarChart, Bar, XAxis, YAxis, Cell, ResponsiveContainer, LabelList } from 'recharts';
import type { ScoreBandDistribution } from '../../../types/skills';

interface ScoreDistributionChartProps {
  distribution: ScoreBandDistribution;
}

/**
 * Horizontal bar chart showing rider distribution across score bands.
 * Always displays all three bands even when count is 0.
 *
 * Requirements: 7.1, 7.2, 7.3, 7.4, 7.5, 7.6, 11.5
 */
export default function ScoreDistributionChart({ distribution }: ScoreDistributionChartProps) {
  const data = [
    { name: '< 50%', count: distribution.belowTarget, color: '#ef4444' },
    { name: '50–75%', count: distribution.mostAtTarget, color: '#eab308' },
    { name: '> 75%', count: distribution.allAtTarget, color: '#22c55e' },
  ];

  const maxCount = Math.max(distribution.belowTarget, distribution.mostAtTarget, distribution.allAtTarget, 1);

  return (
    <div className="w-full rounded-lg border border-gray-200 bg-white p-4">
      <h3 className="mb-1 text-base font-semibold text-gray-700">Rider Skill Mastery</h3>
      <p className="mb-2 text-sm text-gray-500">
        Count of riders by % of skills mastered
      </p>
      <ResponsiveContainer width="100%" height={140}>
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 4, right: 40, left: 0, bottom: 4 }}
        >
          <XAxis type="number" domain={[0, maxCount]} hide />
          <YAxis
            type="category"
            dataKey="name"
            width={70}
            tick={{ fontSize: 12, fill: '#6b7280' }}
            axisLine={false}
            tickLine={false}
          />
          <Bar dataKey="count" radius={[0, 4, 4, 0]} minPointSize={2} barSize={24}>
            {data.map((entry) => (
              <Cell key={entry.name} fill={entry.color} />
            ))}
            <LabelList dataKey="count" position="right" style={{ fontSize: 12, fill: '#374151' }} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
